import React, { Component } from 'react'
import Button from '../../../components/Button'
import styled from 'styled-components'
import { getSlides } from '../../../lib'

const Section = styled.div`
  padding: 10px;
  * {
    margin: 5px;
  }
`

const SectionGroup = styled.div`
  margin-top: 15px;
  font-size: 22px;
  border-bottom: solid 1px #555;
`



class DocumentOptions extends Component {
  generateDocument = (documentName) => {
    this.props.onGenerateDocument(this.props.unit._id, documentName, this.props.multiChoice)
  }
  render() {
    const {
      multiChoice,
      unit,
      snackbarAlert
    } = this.props
    return (
      <div>
          <SectionGroup>{multiChoice ? 'Multiple Choice' : 'Short Answer'}</SectionGroup>
          <Section>
            <h5>DOCX</h5>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('learnerguide.docx')}>
              Learner Guide
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('auditmapping.docx')}>
              Auditmapping
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('assessmentplan.docx')}>
              Assessment Plan
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('assessormarkingguide.docx')}>
              Assessor Marking Guide
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('sessionplan.docx')}>
              Session Plan
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('practicaltrainingtasks.docx')}>
              Practical Training Tasks
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('finalpracticaltest.docx')}>
              Final Practical Test
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('finaltheorytest.docx')}>
              Final Theory Test
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('trainingsignoff.docx')}>
              Training Sign-Off
            </Button>
          </Section>
          <Section>
            <h5>PDF</h5>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('readmefirst.pdf')}>
              Readme First
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('readmefirst-licensed.pdf')}>
              Readme First - Licensed
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('readmefirst-no-ptt.pdf')}>
              Readme First - No PTT
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('readmefirst-hr.pdf')}>
              Readme First - HR
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('readmefirst-lb.pdf')}>
              Readme First - LB
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('learnerguide-sample.pdf')}>
              Learner Guide Sample
            </Button>
            <Button
              raised
              primary
              onClick={() =>
                this.generateDocument('finaltheorytest-sample.pdf')}>
              Final Theory Test Sample
            </Button>
          </Section>
          <Section>
            <h5>PPTX</h5>
            <Button
              raised
              primary
              disabled={getSlides(unit, 'presentation').length === 0}
              onDisabledClick={() =>
                snackbarAlert(
                  'Please initialise slides before generating a presentation',
                )}
              onClick={() =>
                this.generateDocument('presentation.pptx')}>
              Presentation
            </Button>
            {unit.sections.map((section, i) => (
              <Button
                key={`elearning${i}`}
                raised
                primary
                disabled={getSlides(unit, 'eLearningPresentation').length === 0}
                onDisabledClick={() => {
                  snackbarAlert(
                    'Please initialise slides before generating a presentation',
                  )
                }}
                onClick={() =>
                  this.generateDocument(`elearning-presentation[${i}].pptx`)}>
                eLearning Section {i + 1} Presentation
              </Button>
            ))}
          </Section>
      </div>
    )
  }
}

export default DocumentOptions



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/GenerateDocuments/DocumentOptions.js